var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quality-course-container"},[_c('HeaderModule'),_c('div',{staticClass:"student-main-body"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }